/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */
import { Component, Input } from '@angular/core';

// Our custom imports
import FamilyMember from '../family-member.model';

/**
 * Base implementation for containers used within the family member module.
 */
@Component({
  selector: 'base-container',
  templateUrl: './family-member-base-container.component.html',
  host: {
    '[style.height.px]': 'height',
    '[style.width.px]': 'width',
  },
  standalone: false,
})
export class FamilyMemberBaseContainerComponent {
  // Debug flag:
  protected debug : boolean = false;

  @Input() containerType: String;

  @Input() member: FamilyMember;

  @Input() activity : any;

  public blockType : String = '';

  public height : Number = 50;

  public width: Number = 500;
}
